import { Toaster } from './components/ui/toaster';
import router from './router';
import { useAdmin } from './state/use-admin';

import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

function App() {
	const queryClient = useAdmin(state => state.queryClient);

	return (
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
			<Toaster />
		</QueryClientProvider>
	);
}

export default App;

